import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/opt/hotlistcasino/frontend/src/app/[lang]/login/ui.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthPageShell"] */ "/opt/hotlistcasino/frontend/src/components/AuthPageShell.tsx");
